import type { CommunityDetail } from '@pba/react-network';
import { Avatar, Card, Col, DetailsCategoryItem, Icon, Row } from 'ui';
import { images } from 'common/utils';
import { useGetCommunityPrivacyInformation } from './hooks';

type P = {
  community: CommunityDetail;
};

const CommunityDetailsCard = ({ community }: P) => {
  const privacyInformation = useGetCommunityPrivacyInformation({ privacy: community.privacy });

  return (
    <Card title={<Card.Title icon={<Icon icon="information-line" />}>Details</Card.Title>}>
      <Row gutter={[0, 'ms']}>
        <Col span={24}>
          <DetailsCategoryItem
            category="Organization"
            icon={
              <Avatar
                alt="Organization profile photo"
                fallbackPhoto={images.default.organizationProfilePhoto}
                size="lg"
                src={community.organization.profilePhoto}
              />
            }
            name={community.organization.name}
          />
        </Col>
        <Col span={24}>
          <DetailsCategoryItem
            category="Privacy"
            description={privacyInformation.description}
            icon={privacyInformation.icon}
            name={privacyInformation.name}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default CommunityDetailsCard;
